import Vue from 'vue'
import App from './main/views/App.vue'
import router from './main/router'
import store from './main/store'
import zqylModuleFunction from 'zqyl-module-function'
import ElementUI from 'element-ui';
import './main/global/'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2'
import VueAwesomeSwiper from 'vue-awesome-swiper'//滑动翻页
import VueWechatTitle from 'vue-wechat-title'//微信标题

import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/common.less'
import './main/assets/style/style.less'
import './main/assets/style/feedBack.less'
import 'swiper/dist/css/swiper.css'
Vue.prototype.$function = zqylModuleFunction;

import 'vant/lib/index.css';
import 'vant/lib/icon/local.css'
Vue.use(VueWechatTitle)

import { STATUSCODE } from "@/main/assets/js/defined.js";
import INTERFACE from '@/main/assets/interface/lx.js';


import { vueBaberrage } from 'vue-baberrage'
Vue.use(vueBaberrage)


var invaldTitle = '';
router.beforeEach((to, from, next) => {
    //路由发生变化判断特定页面 是否有数据 跳转失效
    let key = to.query.key || '';
    if (key) {
        Vue.prototype.$axios.get(INTERFACE.shareDataObtain, { params: { key: key } }).then(res => {
            if ((res.data.status == STATUSCODE.code01) && res.data.data.data) {
                //路由发生变化修改页面title
                document.title = to.meta.title;
                next()
            } else {
                if (to.path == "/Lx/H5/repayment.htm") {
                    invaldTitle = '云信还款提醒';
                }
                if (to.path == "/Lx/H5/financing.htm") {
                    invaldTitle = '云信融资详情';
                }
                if (to.path == "/Lx/H5/examine.htm") {
                    invaldTitle = '企业认证审批拒绝详情';
                }
                if (to.path == "/Lx/H5/corporateFriends.htm") {
                    invaldTitle = '好友邀请';
                }
                if (to.path == "/Lx/H5/imprintDocument.htm") {
                    invaldTitle = '文件分享';
                }
                document.title = invaldTitle;
                router.push({ name: 'invalid', params: { title: invaldTitle } });
            }
        })
    } else {
        //路由发生变化修改页面title 
        if (to.meta.title) {
            document.title = to.meta.title
        } else {
            if (to.path == '/Lx/H5/invalid.htm') {
                document.title = invaldTitle;
            } else if (to.path == '/yz/form/result.xhtml') {
                document.title = from.meta.title;
            } else {
                document.title = "中企云链";
            }
        }
        next()
    }
});

async function getConfig() {
    return Vue.prototype.$axiosJson.get("/zqyl-app/project.config.json").then(res => {
        let config = res.data;
        localStorage.setItem("config", JSON.stringify(config));
        Vue.prototype.$config = config;
    })
}


Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(VueClipboard);
Vue.use(VueAwesomeSwiper);

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: 'b1c0e3e22302921e6515797160aec7be',
    plugin: ['AMap.Geocoder'],
    v: '1.4.15'
});
async function createApp() {
    return new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount(document.body.appendChild(document.createElement("div")))
}

async function setUserAgent() {
    if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        // alert("移动端")
        // return true; // 移动端
    } else {
        store.commit("setYmtHeader")
        // alert("PC端")
        // return false; // PC端
    }
    // console.log(location.search)
    // if(location.search.indexOf("lianxinapp") != -1){
    // 	store.commit("setYmtHeader")
    // }
    window.addEventListener('popstate', function (e) {
        router.isBack = true
    }, false)
}

async function setServerVersion () {
	await Vue.prototype.$axiosJson.get("/zqyl-app/serverConf.json").then(res=>{
		let version = res.data.namespace || ""
		window.namespace = version;
	}).catch((e)=>{
		throw Error(e)
	})
}

(async function () {
    await setServerVersion()
    await getConfig();
    await createApp();
    await setUserAgent();
})();
